
// SVG Icon: revert
export default { id: "terriajs-revert" };
export const id = "terriajs-revert";
export const name = "revert";
